import { useMutation } from 'react-query';
import apiFetch, { defaultApiFetchErrorHandler } from 'react-scale/lib/api-fetch';

export const useMutateManagerInfo = () => {
  return useMutation<
    any,
    Error,
    {
      workerId: string;
      podType: string;
    }
  >(async ({ workerId, podType }) => {
    try {
      const body = {
        workerId,
        podType,
      };

      const userInfo = await apiFetch<{ user: any }>(
        null,
        `internal/expert-management/updateManagerInfo`,
        {
          method: 'POST',
          body,
        } as any,
      );

      return userInfo;
    } catch (e) {
      defaultApiFetchErrorHandler(e, { handleHttp: true });
      return;
    }
  });
};
